import { Type, type Static } from "@sinclair/typebox";
import { DOCUMENT_VIEW_RESULT_MAX_LIMIT } from "../document-organization.ts";
import {
  DOCUMENT_VIEW_SCHEMA_VERSION,
  DocumentViewCreateProperties,
  DocumentViewCursorSchema,
  DocumentViewRecordProperties,
  DocumentViewResultDocumentSchema,
  DocumentViewUpdateProperties
} from "./common.ts";

export const RecentDocumentsConfigurationSchema = Type.Object({}, { additionalProperties: false });
export type RecentDocumentsConfigurationV2 = Static<typeof RecentDocumentsConfigurationSchema>;

export const RecentDocumentsViewSchema = Type.Object(
  {
    ...DocumentViewRecordProperties,
    viewType: Type.Literal("recent_documents"),
    configuration: RecentDocumentsConfigurationSchema
  },
  { additionalProperties: false }
);
export type RecentDocumentsViewV2 = Static<typeof RecentDocumentsViewSchema>;

export const RecentDocumentsViewCreateInputSchema = Type.Object(
  {
    ...DocumentViewCreateProperties,
    viewType: Type.Literal("recent_documents"),
    configuration: RecentDocumentsConfigurationSchema
  },
  { additionalProperties: false }
);

export const RecentDocumentsViewUpdateInputSchema = Type.Object(
  {
    ...DocumentViewUpdateProperties,
    viewType: Type.Literal("recent_documents"),
    configuration: RecentDocumentsConfigurationSchema
  },
  { additionalProperties: false }
);

export const RecentDocumentsViewResultSchema = Type.Object(
  {
    schemaVersion: Type.Literal(DOCUMENT_VIEW_SCHEMA_VERSION),
    viewType: Type.Literal("recent_documents"),
    viewId: Type.String({ format: "uuid" }),
    viewRevision: Type.Integer({ minimum: 0 }),
    documents: Type.Array(DocumentViewResultDocumentSchema, {
      maxItems: DOCUMENT_VIEW_RESULT_MAX_LIMIT
    }),
    nextCursor: DocumentViewCursorSchema
  },
  { additionalProperties: false }
);
export type RecentDocumentsViewResultV2 = Static<typeof RecentDocumentsViewResultSchema>;
